import AspectWrapper from "core-web/components/AspectWrapper";
import BleedWrapper from "theme/components/wrappers/BleedWrapper";
import Loading from "theme/components/Loading";
import PropTypes from "prop-types";
import React from "react";
import styled from "theme/libs/styled";

const Wrapper = styled(AspectWrapper)`
    position: relative;
    width: 100%;

    & > div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const ModulesLoading = ({ height, ratio, ...rest }) => {
    const setting = ratio ? { ratio } : { height };

    return (
        <BleedWrapper>
            <Wrapper {...rest} {...setting}>
                <Loading />
            </Wrapper>
        </BleedWrapper>
    );
};

ModulesLoading.propTypes = {
    height: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    ratio: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
};

ModulesLoading.defaultProps = {
    height: "90vh",
    ratio: null,
};

export default ModulesLoading;
